import React, { Component } from 'react';
import CellContainer from '../CellContainer';
import styled from 'styled-components';
import Icon from '../../Icon';
import Parser from 'react-html-parser';
import { I18n } from 'react-redux-i18n';

const BigTextContainer = styled.div`
  white-space: ${(props) => (props.open ? 'normal' : 'nowrap')};
  width: 95%;
  display: ${(props) => (props.open ? 'inline' : 'flex')};
  flex-direction: row;
  * {
    display: ${(props) => (props.open ? 'inline' : 'bloc')};
  }

  .actionTextContainer {
    display: ${(props) => (props.open ? 'inline-flex' : 'flex')};
    flex-direction: row;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    align-items: center;
    margin-left: auto;
    p {
      margin-left: 2px;
      text-decoration: underline;
      color: ${(props) => (props.open ? '#adb5bd' : '#e25d34')};
    }
  }

  .eyeClosedContainer {
    color: #adb5bd;
    font-size: 13px;
    width: 13px;
    height: 11px;
    margin-bottom: 3px;
    display: inline-flex;
    margin-left: 5px;
  }
`;

export default class CellBigText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  transform(node) {
    if (node.name === 'a') {
      return (
        <a href={node.attribs.href} target="_blank" rel="noreferrer">
          {I18n.t('link')}
        </a>
      );
    }
  }

  handleLink(text) {
    return Parser(text);
  }

  render() {
    let { value, otherProps } = this.props;
    const { open } = this.state;

    return (
      <CellContainer {...otherProps}>
        {open ? (
          <BigTextContainer open={open}>
            {value.startsWith('Vous devez vous abonner sur') ? (
              Parser(value, { transform: this.transform })
            ) : (
              <p>{value}</p>
            )}
            <div className="actionTextContainer">
              <div className="eyeClosedContainer">
                <Icon icon="eyeClosed" />
              </div>
              <p onClick={() => this.setState({ open: false })}>
                {I18n.t('hide')}
              </p>
            </div>
          </BigTextContainer>
        ) : (
          <BigTextContainer>
            <p>
              {String(value).substring(0, window.innerWidth > 845 ? 40 : 30)};
            </p>
            <div className="actionTextContainer">
              <p onClick={() => this.setState({ open: true })}>
                <Icon icon="eye" />
              </p>
            </div>
          </BigTextContainer>
        )}
      </CellContainer>
    );
  }
}
